import { lazy } from 'react';

export const PlayerRequestSowForm = lazy(
  () => import('./PlayerRequestSowForm'),
);
